// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"ViewRolePage_contentGrid__1cvj7"};